export default __webpack_public_path__ + "static/media/Icon.1d9062d9.svg";